import { Wordle } from './Wordle'

import './App.css'

function App() {
	return (
		<div className='App'>
			<Wordle />
		</div>
	)
}

export default App
